import { FB_EVENTS, sendFBEvent } from 'commons/fbEvents';
import { logError } from 'commons/logger';
import { getAnalyticsDataFromCartItem } from 'components/consumer/cart/utils';
import { useEffect, useMemo } from 'react';
import {
  formatCityForMeta,
  formatStateForMeta,
  formatZipForMeta,
} from '../useMetaFormattedCityStateZip/helpers/formatLocationDataForMeta';

const useJbEventFBPurchase = (
  customerId = '',
  orderId = '',
  cart = [],
  orderSummary = {},
  shipping = {}
) => {
  const products = useMemo(
    () => cart.map(cartItem => getAnalyticsDataFromCartItem(cartItem)),
    [cart]
  );

  const skus = useMemo(() => products.map(prod => prod.sku), [products]);

  const totalQuantity = useMemo(
    () => products.reduce((acc, prod) => acc + prod.quantity, 0),
    [products]
  );

  const productsFormatted = useMemo(
    () =>
      products.map(prod => {
        const { sku } = prod;
        const price = prod.discountPrice;
        const { quantity } = prod;

        return {
          id: sku,
          item_price: price,
          quantity,
        };
      }),
    [products]
  );

  useEffect(() => {
    window.jbEventFBPurchase = () => {
      if (skus?.length) {
        sendFBEvent(FB_EVENTS.PURCHASE, {
          external_id: customerId ? parseInt(customerId, 10) : null,
          eventID: orderId?.toString(),
          content_ids: skus,
          content_type: 'product',
          contents: productsFormatted,
          currency: 'USD',
          num_items: totalQuantity,
          shipping: orderSummary.total_shipping,
          value: orderSummary.grand_total,
          zp: formatZipForMeta(shipping?.zipcode),
          ct: formatCityForMeta(shipping?.city),
          st: formatStateForMeta(shipping?.state),
        });
      } else {
        logError(new Error('window.jbEventFBPurchase: missing skus'));
      }
    };
  }, [
    customerId,
    orderId,
    orderSummary.grand_total,
    orderSummary.total_shipping,
    productsFormatted,
    shipping?.city,
    shipping?.state,
    shipping?.zipcode,
    skus,
    totalQuantity,
  ]);
};

export default useJbEventFBPurchase;
